import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledProfileFormPanel = styled.div<{ $isEditable: boolean }>`
    padding: 16px;
    margin-bottom: 20px;
    background-color: var(--color-white);
    border-radius: var(--radius-10);
    ${({ $isEditable }) =>
        $isEditable &&
        `
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    `}
`;

export const StyledInfosContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
`;

export const StyledFormPanelHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    height: 32px;
`;

export const StyledActionGroup = styled.div`
    display: flex;
    align-items: center;

    svg {
        cursor: pointer;
    }
`;

export const StyledTitle = styled.span`
    font-size: var(--size-16);
    font-weight: var(--weight-600);
    color: var(--color-primary);
    text-transform: uppercase;

    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;
